import { render } from "./icon_Icon.vue?vue&type=template&id=7158201a"
import script from "./icon_Icon.vue?vue&type=script&lang=js"
export * from "./icon_Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__